
<div class="w-full flex flex-row justify-center card-gallery-main-container font-rubik">
  <section class="w-full max-w-1024 card-gallery-inner-container mx-5">
    <div class="container">
      <div class="header">
        <p class="tagline">{{ tagline }}</p>
        <h1 class="main-heading">{{ heading }}</h1>
        <p class="description">{{ description }}</p>
      </div>
      <div class="feature-container">
        <FeatureCard
          v-for="(feature, index) in features"
          :key="index"
          :is-active="activeIndex === index"
          @mouseenter.native="handleMouseEnter(index)"
          @mouseleave.native="handleMouseLeave"
          :feature="feature"
          :label-background-color="cardLabelBackgroundColor"
          :label-text-color="cardLabelTextColor"
          :feature-content-background-color="featureContentBackgroundColor"
          :feature-content-text-color="featureContentTextColor"
          :page="page"
        />
      </div>
    </div>
  </section>
</div>
